import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { ExternalLink, LogOut, Newspaper } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../admin/AuthContext';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-[#2A0F14] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3" data-testid="admin-home-link">
            <span className="bg-[#D4AF37] text-gray-900 rounded-md p-1.5"><Newspaper className="w-4 h-4" /></span>
            <span className="font-semibold tracking-wide">VB Global · Blog Admin</span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-gray-300" data-testid="admin-user-email">{user?.email}</span>
            <a href="/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-white inline-flex items-center gap-1">
              <ExternalLink className="w-4 h-4" /> View site
            </a>
            <Button size="sm" variant="outline" onClick={logout} data-testid="admin-logout" className="bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white">
              <LogOut className="w-4 h-4 mr-1" /> Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
